import { Component, OnInit } from '@angular/core';
import { CallBackEndService } from '../../../call-back-end.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  bankName: any;

  constructor(webService : CallBackEndService) {
    this.bankName = webService.getBankName();

   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/layout/components/footer/footer.component.ts